import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { FuenteService } from '../../../services/formulacion/fuente.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-fuente',
  templateUrl: './fuente.component.html',
  styleUrls: [],
  providers: [FuenteService]
})
export class FuenteComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceFU: any[];
  model: any = {
    id: 0,
    codigo: '',
    sigla: '',
    titulo: '',
    descripcion: '',
    selector: '',
    es_vigente: true,
  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;
  tipo_agregacion_id: number = 1;;  
  unidad_organizacional_id: number = 0;

  constructor(private _fs: FuenteService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getFuentes();
    let u = JSON.parse(localStorage.getItem('u'));        
    this.tipo_agregacion_id = 1;  
    this.unidad_organizacional_id = u.unidad;      
  }

  ngOnInit() {
  }

  clearErrors(){
    this.hasError = { codigo: false, sigla: false, titulo: false, descripcion: false, selector: false };
  }

  getFuentes() {
    this._fs.getFuente().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceFU = result.data;
          
        } else {
          this.dataResourceFU = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.codigo = '';
    this.model.sigla = '';
    this.model.titulo = '';
    this.model.descripcion = '';
    this.model.selector = '';
    this.model.es_vigente = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.sigla = data.sigla;
    this.model.titulo = data.titulo;
    this.model.descripcion = data.descripcion;
    this.model.selector = data.selector;
    this.model.es_vigente = data.es_vigente;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  concatSelector() {
    this.model.selector = this.model.codigo + ' - ' + this.model.sigla
  }

  saveFuente() {
    this.hasError = { codigo: false, sigla: false, titulo: false, descripcion: false, selector: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._fs.postFuente(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getFuentes();
              this.popupVisibleAdd = false;              
              toastr.success('Datos guardados correctamente.');          
            } else {              
              toastr.warning(result.data); 
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._fs.putFuente(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getFuentes();
              this.popupVisibleAdd = false;              
              toastr.success('Datos guardados correctamente.');          
            } else {              
              toastr.warning(result.data); 
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deleteFuente() {
    this._fs.deleteFuente(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getFuentes();
          this.popupVisibleDel = false;          
          toastr.success('Proceso realizado correctamente.');          
        } else {              
          toastr.warning(result.data);  
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.sigla, 'text')) {
      this.hasError.sigla = true; res = false;
    }
    if (!UtilHelper.validator(data.titulo, 'text')) {
      this.hasError.titulo = true; res = false;
    }
    // if (!UtilHelper.validator(data.descripcion, 'text')) {
    //   this.hasError.descripcion = true; res = false;
    // }
    if (!UtilHelper.validator(data.selector, 'text')) {
      this.hasError.selector = true; res = false;
    }
    return res;
  }
}
